export enum BankAccountType {
  checking = 'CHECKING',
  savings = 'SAVINGS',

  unset = '',
}
